<template>
    <div class="charity-container mx-auto my-3">
      <div v-if="isLoaded">
        <div  v-show="hasActiveChannel" id="twitch-embed" class="mt-1 mb-2 mx-auto border-2 border-black rounded-lg bg-black" :style="{ height: embedHeight, maxWidth: '1100px' }"></div>
        <div class="w-full mx-auto flex flex-col justify-center items-center text-center">
          <div v-show="nextChannel" class="w-full md:w-2/3 underline font-bold"><a :href="'http://www.twitch.tv/' + this.nextChannel" target="_blank">Next Stream: {{  nextChannel }}</a></div>
          <div v-show="nextStartTime" class="w-full md:w-2/3 font-bold">Starting at: {{new Intl.DateTimeFormat(undefined, { year: 'numeric',month: 'short',day: 'numeric',hour: 'numeric',minute: 'numeric',timeZoneName: 'short',}).format(new Date(nextStartTime * 1000))}}</div>
          <img class="w-full md:w-2/3 border-2 border-black rounded-lg mt-2" :src="imagePath" alt="Charity Banner">
        </div>
        <div class="w-full mx-auto pt-2 text-center text-xl font-bold">{{ eventData.title }}</div>
        <div class="w-full mx-auto py-1 text-center text-sm">{{ eventData.charity_description }}</div>
        <div v-if="eventData.activation_or_campaign !== 'none' && campaignInfo" class="flex flex-row w-full md:w-2/3 mx-auto">
          <a class="btn mr-1 px-1" :href="this.campaignInfo.donateUrl" target="_blank">Donate</a>
          <div class="progress-bar-container border-2 border-black rounded-xl" :style="{ backgroundColor: progressPercentage >= 100 ? '#611892' : '#eee' }">
            <div class="progress-bar" :style="{ width: progressPercentage + '%' }">
              <div class="raised-amount" v-show="campaignInfo && campaignInfo.amountRaised > 0">
                ${{ campaignInfo.amountRaised }}
              </div>
            </div>
            <div class="goal-amount" v-if="campaignInfo">
              ${{ campaignInfo.goal }}
            </div>
          </div>
        </div>
        <div class="w-fit mx-auto mt-2 mb-1 text-center text-xl font-bold hover:text-gray-500" @click="isScheduleCollapsed = !isScheduleCollapsed">{{ isScheduleCollapsed ? 'Show' : 'Hide' }} Schedule</div>
          <div v-if="!isScheduleCollapsed" class="sflex flex-col w-full md:w-2/3 justify-center mx-auto bg-gray-100 border border-black rounded-lg">
            <div v-for="streamer in eventData.charity_streamers" :key="streamer.name" :style="{ color: getTextColor(streamer) }" class="streamer flex flex-row w-full md:w-2/3 mx-auto justify-center subtle-shadow">
              <div class="w-1/2 px-1"><a :href="'http://www.twitch.tv/' + streamer.twitch_name" target="_blank">{{ streamer.twitch_name }}</a></div>
              <div class="w-1/2 text-sm px-1">{{ formattedDate(streamer.start_time.unix) }}</div>
            </div>
          </div>
        </div>
      <div v-else-if="hasError" class="error-message-container">
        <p class="error-message">
          Error loading event data.
        </p>
      </div>
    </div>
</template>

<script>
  export default {
    name:'Charity',
    updated() {
      this.$store.commit('setCharityComponentActive', true);
    },
    data() {
      return {
        eventData: null,
        campaignInfo: null,
        isLoaded: false,
        currentChannel: null,
        nextChannel: null,
        nextStartTime: null,
        hasError: false,
        isScheduleCollapsed: true,
      }
    },
    async created() {

    },
    async mounted() {
      window.addEventListener("load", () => {
          const isCampaignInfoLoaded = this.updateActiveChannel(); // Call the method immediately
        if (isCampaignInfoLoaded) {
          this.updateChannelInterval = setInterval(() => {
            this.updateActiveChannel(); // Call the method every 60 seconds
          }, 60000); //^5 TODOME
        } else {
          this.hasError = true;
        }
      });
    },
    beforeDestroy() {
      clearInterval(this.updateChannelInterval);
    },
    computed: {
      progressPercentage() {
        if (this.campaignInfo) {
          return (this.campaignInfo.amountRaised / this.campaignInfo.goal) * 100;
        }
        return 0;
      },
      imagePath() {
        if (this.eventData && this.eventData.charity_banner) {
          return '/images/' + this.eventData.charity_banner;
        }
        return '';
      },
      hasActiveChannel() {
        return !!this.currentChannel;
      },
      embedHeight() {
        const isMobileDevice = window.innerWidth <= 768;
        return isMobileDevice ? 'calc(100vw * 9 / 16)' : 'calc(900px / (16 / 9))';
      },
    },
    watch: {
    },
    methods: {
      async fetchData(url) {
        try {
          // Uncomment the line below to simulate an error
          //throw new Error('Simulated error: Failed to fetch data');

          const response = await fetch(url);
          if (response.ok) {
            return await response.json();
          } else {
            console.error(`Failed to fetch data from ${url}:`, response.status, response.statusText);
            return null;
          }
        } catch (error) {
          console.error(`Error fetching data from ${url}:`, error);
          return null;
        }
      },
      async fetchCampaignInfo() {
        const campaignInfo = await this.fetchData(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/tiltify`);
        if (campaignInfo) {
          this.campaignInfo = campaignInfo;
          this.eventData = campaignInfo.eventData;

          this.eventData.charity_streamers.sort((a, b) => {
            return a.start_time.unix - b.start_time.unix;
          });

          this.$nextTick(() => {
            this.isLoaded = true;
          });
        } else {
          this.hasError = true;
        }
      },
      initTwitchEmbed(channel) {
        setTimeout(() => {
            const embedElem = document.getElementById('twitch-embed');
            if (!embedElem) {
              setTimeout(() => this.initTwitchEmbed(channel), 100); // Retry after a short delay
              return;
            }
            const script = document.createElement('script');
            script.src = 'https://embed.twitch.tv/embed/v1.js';
            script.onload = () => {
              const isMobileDevice = window.innerWidth <= 768;
              const layout = isMobileDevice ? 'video' : 'video-with-chat';// Set layout based on device
              new Twitch.Embed('twitch-embed', {
                width: '100%',
                height: '100%',
                channel: channel,
                layout: layout,
                parent: [process.env.APP_URL],
              });
            };
            document.head.appendChild(script);
          }, 1000);
      },
      removeTwitchEmbed() {
        const embedElem = document.getElementById('twitch-embed');
        if (embedElem.firstChild) {
          embedElem.removeChild(embedElem.firstChild);
        }
      },
      getActiveChannel() {
        const nowUnix = Math.floor(new Date().getTime() / 1000);
        //console.log("Now Unix:", nowUnix);
        let activeStreamer = null;
        let nextStreamer = null;
        let nextStartTime = Infinity;

        this.eventData.charity_streamers.forEach((streamer) => {
          const startUnix = streamer.start_time.unix;
          const endUnix = streamer.end_time.unix;
          // console.log("Streamer:", streamer.twitch_name);
          // console.log("Start time Unix:", startUnix);
          // console.log("End time Unix:", endUnix);
          if (nowUnix >= startUnix && nowUnix <= endUnix) {
            activeStreamer = streamer;
          }
          if (startUnix > nowUnix && startUnix < nextStartTime) {
            nextStreamer = streamer;
            nextStartTime = startUnix;
          }
        });
        return {
          activeStreamer: activeStreamer ? activeStreamer.twitch_name : null,
          nextChannel: nextStreamer ? nextStreamer.twitch_name : null,
          nextStartTime: nextStartTime !== Infinity ? nextStartTime : null,
        };
      },
      async updateActiveChannel() {
        await this.fetchCampaignInfo();
        const channelsInfo = this.getActiveChannel();
        const channel = channelsInfo.activeStreamer;
        this.nextChannel = channelsInfo.nextChannel;
        this.nextStartTime = channelsInfo.nextStartTime;
        const embedElem = document.getElementById("twitch-embed");
        if (channel && channel !== this.currentChannel) {
          this.currentChannel = channel;
          if (embedElem && embedElem.firstChild) {
            this.removeTwitchEmbed();
          }
          this.$nextTick(() => {
            this.initTwitchEmbed(channel);
          });
        } else if (!channel && this.currentChannel) {
          this.currentChannel = null;
          if (embedElem && embedElem.firstChild) {
            this.removeTwitchEmbed();
          }
        }
      },
      formattedDate(inDate) {
        const date = new Date(inDate * 1000);
        
        const timeFormatter = new Intl.DateTimeFormat('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short',
        });
        const dateFormatter = new Intl.DateTimeFormat('en-US', {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
        });

        const formattedTime = timeFormatter.format(date);
        const formattedDate = dateFormatter.format(date);

        return `${formattedTime}, ${formattedDate}`;
      },
      getTextColor(streamer) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current Unix timestamp in seconds

        if (streamer.start_time.unix < currentTime) {
          return 'black';
        } else {
          return streamer.schedule_color;
        }
      },
    },
  };
  </script>
  <style scoped>
  button.active {
      background-color: #007bff;
      color: #fff;
  }
  .btn {
      @apply text-center border border-black rounded-md bg-gray-100 text-gray-700 hover:bg-gray-300;
  }
  .progress-bar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: #eee;
    border-radius: 3px;
  }
  .progress-bar {
    display: flex;
    align-items: center;
    height: 20px;
    background-color: #611892;
    border-radius: 3px;
    padding-left: 4px;
  }
  .raised-amount {
    color: #fff;
  }
  .goal-amount {
    padding-right: 4px;
  }
  .charity-container {
    max-width: 1100px;
  }
  .error-message-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 300px; /* Adjust this value to fit your design */
  }
  .error-message {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }
</style>
